import React from 'react';

import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';

import routes from '../../routes';
import { hasAnyPermission } from '../../utils/permissions';

const passesGate = (item, permissions) =>
  !item.acceptPermissions?.length ||
  hasAnyPermission(permissions, item.acceptPermissions);

const getFirstAccessiblePath = (permissions) => {
  for (const route of routes) {
    if (route.hidden) continue;

    if (route.children?.length) {
      for (const child of route.children) {
        const visible =
          (child.hidden === undefined || !child.hidden) &&
          (child.acceptPermissions?.length
            ? passesGate(child, permissions)
            : passesGate(route, permissions));
        if (visible) return `${route.path}${child.path}`;
      }
    } else if (passesGate(route, permissions)) {
      return route.path;
    }
  }
  return null;
};

const HomeRedirect = () => {
  const permissions = useSelector(
    (state) => state.auth.auth.details?.permissions || []
  );

  const path = getFirstAccessiblePath(permissions);

  if (path) return <Redirect to={path} />;

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h4>No accessible pages</h4>
      <p>
        You don't have permission to view any section. Please contact your
        administrator.
      </p>
    </div>
  );
};

export default HomeRedirect;
